import React, { Component } from "react";
import { Table } from "reactstrap";
import ServerPaginatedTable from "../../components/ServerPagination";
import { appHelpers } from "../../_helpers";


export const BulkPaymentTable = ({ apiData }) => {
  const handleRowClick = (item) => {
    // Store the selected item data (sessionStorage keeps it for the session only)
    sessionStorage.setItem("selectedWalletData", JSON.stringify(item));
 
    // Navigate to wallet history page
    window.location.href = "/wallet-history";
  };
  return (
    <Table responsive striped hover style={{cursor: "pointer"}}>
    <thead className={"table-head-blue"}>
        <tr>
          <th style={{ padding: "none" }}>Customer name</th>
          <th style={{ padding: "none" }}>ID</th>
          <th style={{ padding: "none" }}>Balance</th>
          <th style={{ padding: "none" }}>Last transaction</th>
        </tr>
      </thead>
      <tbody>
        {apiData.map((item, index) => {
          return (
            <tr key={index} style={{ borderTop: "12px solid transparent" }} 
            onClick={() => handleRowClick(item)}>
              <th>{item.customerName}</th>
              <th>{item.walletNumber}</th>
              <th>{appHelpers.numberWithCommasOnly(item.balance)}</th>
              <th>{appHelpers.numberWithCommasOnly(item.lastTransactionAmount)}</th>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default class TableFormat extends Component {
  render() {
    let {
      apiData,
      currentPage,
      fetchMore,
      pageSize,
      totalCount,
    } = this.props;
    const pageIndex = currentPage === 0 ? 1 : pageSize * (currentPage - 1) + 1;
    return (
      <div>
        <ServerPaginatedTable
          currentPage={currentPage}
          fetchMore={fetchMore}
          pageSize={pageSize}
          totalCount={totalCount}
          positionBottomPagination={"left"}
          showBottomPagination
          target={<BulkPaymentTable apiData={apiData} pageIndex={pageIndex} />}
        />
      </div>
    );
  }
}
